module.exports = "build/assets/mobileMonk.cb1fa6df.png";